import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header, Button, Divider } from "semantic-ui-react";

import LimitTable from "../../components/account/LimitTable.jsx";

import { selectTestingEnvironment } from "../../state/reducers/config/configSelectors.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class LimitTab extends PureComponent {
  static propTypes = {
    testingEnvironment: PropTypes.string,
    user: PropTypes.object.isRequired,
    requestLimitHandler: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  // -- RENDER -- //

  render() {
    const { user, requestLimitHandler, testingEnvironment, copy } = this.props;

    return (
      <Segment vertical padded textAlign="left">
        <Header as="h3">{copy("account.limits.title")}</Header>
        <p>{copy("account.limits.body")}</p>
        <LimitTable data={user} />

        {/*
        -- @todo due to the demise of the Zendesk support widget, we have to come up with an alternative - in the meantime: hide the "request limit increase"-button -- //
        */}

        {/*
        {testingEnvironment && (
          <Fragment>
            <Button onClick={requestLimitHandler} floated="right">
              {copy("account.limits.request.cta")}
            </Button>
            <Divider hidden />
          </Fragment>
        )}
        */}
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  testingEnvironment: selectTestingEnvironment(state),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(LimitTab);
